import React from 'react';

import type { SidebarDividerProps } from './Sidebar.types';

import { SectionLabel } from '@/components/ui/primitives';

/**
 * Section divider for sidebar navigation.
 *
 * Displays an uppercase section label matching the design template style:
 * - 11px font size, 600 weight for legibility on dark themes
 * - Uppercase with wide letter-spacing
 * - neutral-500 color for subtle hierarchy
 * - No horizontal line (label-only pattern)
 *
 * When collapsed, renders a thin horizontal separator line instead.
 */
export function SidebarDivider({
  label,
  collapsed = false,
}: SidebarDividerProps): React.JSX.Element {
  // When collapsed, show a subtle horizontal line separator
  if (collapsed) {
    return (
      <div className="sidebar-divider my-4 px-3">
        <div className="h-px bg-stroke-default" />
      </div>
    );
  }

  // When expanded, show the section label
  return (
    <div className="sidebar-divider mb-2 mt-6 px-3">
      <SectionLabel as="span">{label}</SectionLabel>
    </div>
  );
}

export default SidebarDivider;
